import { Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { FIELDS } from '../constants';
import { getTransportContentSx, getTransportLabelSx } from './transportTypographySx';
import YesNoToggle from './YesNoToggle';

EscortDetails.propTypes = {
  aideRequired: PropTypes.bool,
  unitAideRequired: PropTypes.bool,
  cnaRequired: PropTypes.bool,
  setter: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  detailsMode: PropTypes.bool,
};

export default function EscortDetails({
  aideRequired,
  unitAideRequired,
  cnaRequired,
  setter,
  disabled = false,
  detailsMode = false,
}) {
  return (
    <Grid
      container
      spacing={2}
      mt={0}
      alignItems="center"
      sx={{
        '& > .MuiGrid-item': { pt: 1 },
      }}
    >
      <Grid item>
        <Typography color="text.secondary" sx={getTransportLabelSx(detailsMode)}>
          Escort Details:
        </Typography>
      </Grid>
      <Grid item>
        <YesNoToggle
          title="Aide Required?*"
          setter={(value) => setter(FIELDS.AIDE_REQUIRED, value)}
          value={aideRequired}
          titleSx={getTransportContentSx(detailsMode)}
          detailsMode={detailsMode}
          disabled={disabled}
        />
      </Grid>
      <Grid item>
        <YesNoToggle
          title="Unit Aide?*"
          setter={(value) => setter(FIELDS.UNIT_AIDE_REQUIRED, value)}
          value={unitAideRequired}
          titleSx={getTransportContentSx(detailsMode)}
          detailsMode={detailsMode}
          disabled={disabled}
        />
      </Grid>
      <Grid item>
        <YesNoToggle
          title="CNA?*"
          setter={(value) => setter(FIELDS.CNA_REQUIRED, value)}
          value={cnaRequired}
          titleSx={getTransportContentSx(detailsMode)}
          detailsMode={detailsMode}
          disabled={disabled}
        />
      </Grid>
    </Grid>
  );
}
